import { useEffect, useRef, useState } from "react";
import { Search, Sparkles, Flame, GraduationCap } from "lucide-react";
import { useTerminal } from "@/lib/terminal";
import { TokenRow } from "@/components/TokenRow";
import { Skeleton } from "@/components/ui/skeleton";

const COLS = [
  { key: "new", title: "Yeni Çıkanlar", icon: Sparkles, color: "#00E676" },
  { key: "stretch", title: "Bonding Eğrisinde", icon: Flame, color: "#FFD700" },
  { key: "migrated", title: "Graduated", icon: GraduationCap, color: "#00F0FF" },
];

const Column = ({ col, items, seen, q }) => {
  const Icon = col.icon;
  const list = (items || []).filter((p) => !q || `${p.token.symbol} ${p.token.name} ${p.token.address}`.toLowerCase().includes(q));
  return (
    <section className="flex flex-col min-h-0 border border-[#222634] bg-[#101216] rounded-md overflow-hidden" data-testid={`pulse-column-${col.key}`}>
      <header className="flex items-center gap-2 px-3 h-10 border-b border-[#222634] bg-[#0D0F13]">
        <Icon className="w-4 h-4" style={{ color: col.color }} />
        <h2 className="text-sm font-semibold text-slate-200">{col.title}</h2>
        <span className="ml-auto text-xs font-mono text-slate-500">{list.length}</span>
      </header>
      <div className="flex-1 overflow-y-auto terminal-scroll">
        {!items && Array.from({ length: 8 }).map((_, i) => <Skeleton key={i} className="h-16 m-2 bg-[#161920]" />)}
        {items && list.length === 0 && <p className="p-6 text-sm text-slate-500">Token yok</p>}
        {list.map((p) => <TokenRow key={p.token.address} p={p} fresh={seen.current.size > 0 && !seen.current.has(p.token.address)} />)}
      </div>
    </section>
  );
};

export default function Pulse() {
  const { api } = useTerminal();
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  const seen = useRef(new Set());
  const prev = useRef(new Set());

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const d = await api("get", "/pulse");
        if (!alive) return;
        seen.current = prev.current;
        prev.current = new Set([...d.new, ...d.stretch, ...d.migrated].map((p) => p.token.address));
        setData(d);
      } catch {}
    };
    load();
    const t = setInterval(load, 4000);
    return () => { alive = false; clearInterval(t); };
  }, [api]);

  return (
    <div className="flex flex-col gap-3 h-[calc(100vh-5.5rem)]">
      <div className="flex items-center gap-3">
        <h1 className="text-xl font-bold tracking-tight">Pulse</h1>
        <span className="flex items-center gap-1.5 text-xs font-mono text-[#00E676]"><span className="w-1.5 h-1.5 rounded-full bg-[#00E676] live-dot" />CANLI · full.fun</span>
        <div className="ml-auto flex items-center gap-2 px-2.5 h-8 w-full max-w-xs rounded border border-[#222634] bg-[#101216] focus-within:border-[#333A4E]">
          <Search className="w-4 h-4 text-slate-500" />
          <input data-testid="token-search-input" value={q} onChange={(e) => setQ(e.target.value.toLowerCase())} placeholder="Sembol, isim veya adres" className="bg-transparent outline-none text-sm flex-1" />
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 flex-1 min-h-0">
        {COLS.map((c) => <Column key={c.key} col={c} items={data?.[c.key]} seen={seen} q={q} />)}
      </div>
    </div>
  );
}
